import React from 'react'
import {observer} from 'mobx-react-lite'
import {Outlet} from 'react-router-dom'

import {OnboardingLayout} from '@/layouts/OnboardingLayout'
import {Theme} from '@/constants'
import {Footer} from '@/components/composite/Footer/Footer'

type AuthAreaProps = {theme?: Theme}

export const OnboardingArea = observer((props: AuthAreaProps) => {
    return (
        <>
            <OnboardingLayout theme={props.theme}>
                <Outlet />
            </OnboardingLayout>
            <Footer />
        </>
    )
})
